import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import { membershipHighlightedFeaturesData } from '@/app/[locale]/membership/_data/membershipHighlightedFeaturesData';
import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';

const MembershipFeatures = () => {
  const t = useTranslations();
  return (
    <section
      className="relative pt-10 pb-14 md:px-5 md:pb-20 lg:pt-12 lg:pb-24"
      data-cy="membership-features"
    >
      <LayoutGrid className="h-full content-between">
        <GridItem
          colStart={{ sm: 'main', md: 3, lg: 3 }}
          colEnd={{ sm: 'main', md: 23, lg: 23 }}
        >
          <TypographyV3
            Element="h2"
            variant="h3"
            className="mb-10 text-3xl md:mb-14 lg:text-5xl"
            height="normal"
            data-cy="membership-features-title"
          >
            {t('membership_features_title')}
          </TypographyV3>
        </GridItem>

        <GridItem
          colStart={{ sm: 'main', md: 3, lg: 3 }}
          colEnd={{ sm: 'main', md: 23, lg: 23 }}
          className="relative"
        >
          <div className="grid gap-y-8 md:grid-cols-2 md:gap-9 lg:grid-cols-4">
            {membershipHighlightedFeaturesData.map((feature) => (
              <div className="flex flex-col" key={feature.id}>
                <div
                  className="relative mb-3 aspect-2000/2667 w-full"
                  data-cy={`membership-features-image-${feature.id}`}
                >
                  <ArtDirectionImage
                    srcSet={[
                      {
                        src: feature.image.src,
                      },
                    ]}
                    alt={t(feature.image.alt)}
                    sizes="(max-width: 768px) 80vw,(max-width: 1200px) 50vw, 25vw"
                    fill
                    className="object-cover"
                  />
                </div>
                <div>
                  <TypographyV3
                    data-cy={`membership-features-text-${feature.id}`}
                  >
                    {t(feature.text)}
                  </TypographyV3>
                </div>
              </div>
            ))}
          </div>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default MembershipFeatures;
